export type EmailValues = {
    firstName: string;
    lastName: string;
    email: string;
    confirmEmail: string;
    phoneNumber: string;
    enquiry: string;
    captcha: string;
}

export const initialValues: EmailValues = {
    firstName: '',
    lastName: '',
    email: '',
    confirmEmail: '',
    phoneNumber: '',
    enquiry: '',
    captcha: '',
}

export const initialValuesTest2: EmailValues = {
    firstName: 'innerRef@hot.com',
    lastName: 'innerRef@hot.com',
    email: 'innerRef@hot.com',
    confirmEmail: 'innerRef@hot.com',
    phoneNumber: 'innerRef@hot.com',
    enquiry: 'enquiry',
    captcha: '',
}


export const initialValuesTest: EmailValues = {
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email@email.com',
    confirmEmail: 'confirmEmail@email.com',
    phoneNumber: '0400000000',
    enquiry: 'enquiry',
    captcha: '',
}
